export default [
    { value: "BAJ", label: "Deuda Baja" },
    { value: "MED", label: "Deuda Mediana" },
    { value: "ALT", label: "Deuda Alta" },  
  ];
